import React, { useEffect, useState, useRef } from "react";
import { Table, Input } from "antd";
// import { getApplications } from "../auth/services/privateapicalling";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { label } from "yet-another-react-lightbox/*";
import { getApplications, getOneApplicationDetail } from "../../auth/services/privateapicalling";
import SingleView1 from "../../pages/pdfloader/Singleview1";
import LicenseView1 from "../../pages/pdfloader/LicenseView";


interface StatusProp {
  status: string;
  
}



const MyApplication: React.FC<StatusProp> = ({ status }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [Selections, setSelections] = useState<boolean>(true);
  const [applicationData, setApplicationData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(5); // Default limit
  const [totalItems, setTotalItems] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
   const [application, setApplication] = useState<any | null>(
      null
    );
     const language = useSelector((state: any) => state.auth.language);
const [selectedDocId, setSelectedDocId] = useState<string | null>(null);
const roleIdentifier = useSelector(
    (state: any) => state.auth.userDetails?.Role?.Role_Identifier
  );
  // const [selectedStatus, setSelectedStatus] = useState<Option | null>(status[0]);

  const token = useSelector((state: any) => state.auth.token);
  const navigate = useNavigate();
  const debounceTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  // const onSelectChange = (newSelectedRowKeys: any[]) => {
  //   setSelectedRowKeys(newSelectedRowKeys);
  // };

    const fetchApplicationDetails = async (appId: any) => {
      try {
        //.log("fff");
        //.log("apppidddd", appId);
        const data = await getOneApplicationDetail(appId, token);
        //.log("datdatadataa", data);
        if(!data?.success){
          navigate("/error-404")
         }
       
  
        setApplication(data.data);
     
  
        const application = data?.data;
  
        const rejectedDocs = application?.rejectedDocName;
        const rejectedFields = application?.rejectedFieldName;
      
  
        const app = data.data;
        const curradd = app.currAddress;
        //.log("ccc", curradd);
        // setAddressData(curradd);
      } catch (err) {
        // setError("Failed to load application details");
      } finally {
        setLoading(false);
        //.log("apppp", application);
      }
    };



useEffect(() => {
  fetchApplicationDetails(applicationData[0]?.applicationId);

  
}, [applicationData]);


  const columns = [
    {
      title: "Application Id",
      dataIndex: "applicationId",
      render: (text: string) => (
        <h6 className="fw-medium">
          <Link to="#">{text}</Link>
        </h6>
      ),
    },
    { title: "Trader Name", dataIndex: "applicantName" },
    { title: "Applicant Type", dataIndex: "entityType" },
 
    {
      title: "License Type",
      dataIndex: "licenseType",
      render: (text: string, record: any) => {
        // Append year if licenseType is 1 or 3 and year is present
    
        return text+" "+"year";
      }
    },
    { title: "APMC", dataIndex: "apmc" },
    { 
      title: "Applied Date", 
      dataIndex: "appliedDate",
      render: (date: string) => date ? new Date(date).toLocaleDateString("en-GB") : "N/A" 
    },
    { title: "Payment Status", dataIndex: "paymentStatus" },
    
    {
      title: "Application Status",
      dataIndex: "status",
      render: (status: string) => {
        const statusMapping: Record<string, string> = {
          permanentReject: "Permanent reject",
          approvedUnsigned: "Approve Unsigned",
          approve:"Approved by Department",
          reject: "Raised Query By Department",
          pending:"Review under Department",
          resubmission: "Resubmission",
          draft:"Draft"
        };

        return <span>{statusMapping[status] || status}</span>;
      },
    },
    {
      title: "Action",
      dataIndex: "applicationId",
      render: (text: string, record: any) => {
        if(record?.status==="approve")
        {
// fetchApplicationDetails(record.applicationId)
        }
      return ( <div className="d-flex">
          <button
            className="bg-primary rounded text-white px-4 py-2"
            onClick={() =>
             navigate(`/application/${record.applicationId}`)
            }
          >
            Preview
          </button>
           
                                  
                              
      
          {record?.status == "approve" && (
                                      <div className="ps-2 ">
                                    
          
                                         {/* {(() => {
                                          const latestLicense = application?.docs
                                            .filter((doc: any) =>
                                              doc.documentName.toLowerCase().includes("license")
                                            )
                                            .at(-1); // Get the last license
          
                                          return latestLicense ? ( */}
                                            <Link
                                              key={record.applicationId}
                                              to="#"
                                              data-bs-toggle="modal"
                                              data-inert={true}
                                              data-bs-target="#license_modal"
                                              className="btn btn-success align-items-center"
                                              onClick={() => setSelectedDocId(record.applicationId)}
                                            >
                                              {language.download_license}
                                            </Link>
                                      </div>
                                    )}
                                    </div>)
      },
    },
  ];

  const EntityOptions = [
    { value: "Ind", label: "Individual" },
    { value: "Firm", label: "Firm" },
    { value: "Company", label: "Company" },
    { value: "CoSciety", label: "Cooperative Society" },
    { value: "Fpo", label: "Farmer Producer Organization (FPO)" },
    { value: "govEnt", label: "Government Entity" },
    { value: "Ngo", label: "Non-Governmental Organization (NGO)" },
    { value: "partnerFirm", label: "Partnership Firm" },
    { value: "Llp", label: "Limited Liability Partnership (LLP)" },
    { value: "Trust", label: "Trust" },
    { value: "Jv", label: "Joint Venture" },
  ]; 



  const fetchApplication = async (
    status: string,
    page: number,
    searchApplicationById: string = "",
    limit: number,
    
  ) => {
    setLoading(true);
    try {
      const appdata = await getApplications(
        status,
        token,
        page,
        searchApplicationById,
        limit,
        roleIdentifier
      );
      //.log("Fetched Data:", appdata);

      if (appdata?.success) {
        setApplicationData(appdata.data || []);
        setTotalItems(appdata.totalCount || 0);
      }
    } catch (error) {
      //.error("Error fetching applications:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleSearch = (value: string) => {
    setSearchQuery(value);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      fetchApplication( status ,1, value, limit ); 
      setCurrentPage(1); 
    }, 500); 
  };


  useEffect(() => {
    fetchApplication(status , currentPage, searchQuery, limit); 
  }, [currentPage, status, limit]);



  return (
    <>
    
      <div className="table-top-data">
        <div className="row p-3">
          <div className="col-sm-12 d-flex justify-content-end">

            <Input
              placeholder="Search Application Id..."
              value={searchQuery}
              onChange={(e) => handleSearch(e.target.value)}
              style={{ width: 250 }}
              allowClear
            />
          </div>
        </div>
      </div>

    
      <Table
        className="table datanew dataTable no-footer"
        // rowSelection={Selections ? rowSelection : undefined}
        columns={columns}
         rowKey={"applicationId"}
        rowHoverable={false}
        // dataSource={applicationData}
        dataSource={applicationData.map((item) => ({
          ...item,
          entityType: EntityOptions.find((option) => option.value === item.entityType)?.label || item.entityType,
        }))}
        loading={loading}
        pagination={{
          locale: { items_per_page: "" },
          nextIcon: <i className="ti ti-chevron-right" />,
          prevIcon: <i className="ti ti-chevron-left" />,
          pageSize: limit, 
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "30"],
          current: currentPage,
          total: totalItems,
          showTotal: (total, range) =>
            `Showing ${range[0]} - ${range[1]} of ${total} entries`,
          onChange: (page, pageSize) => {
            setCurrentPage(page);
            setLimit(pageSize); 
          },
        }}
      />
         <LicenseView1 docId={selectedDocId} />
    </>
  );
};

export default MyApplication;
